// Sample details router
export default [
  {
    path: 'samples/details/:sampleId',
    name: 'sampleDetails',
    component: () =>
      import(
        /* webpackChunkName: "sampleDetails" */ '../views/sampleDetails/sampleDetails.vue'
      ),
    meta: {
      tabbable: true,
      dynamicTabKey: 'sampleId',
      dynamicTableKeysBase: 'sampleDetails',
      tableKeys: [],
      filterKeys: [],
      formKeys: [],
      routePermissions: ['analysesDataView', 'analysesStatusView'],
    },
  },
];
